module.exports = __webpack_public_path__ + "img/cu_sac.84adfc98.svg";